import {Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit, ChangeDetectorRef, ElementRef, HostListener} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {CustomListDataSourceService} from '../custom-list-data-source.service';
import { ColumnDefinition } from '../../../models/table-config.interface';

interface CustomListColumn extends ColumnDefinition {
  key: string;
  label: string;
  template?: any;
  sort?: boolean;
  width?: string;
  valueTransform?: (val: any, row: any) => string;
}
@Component({
  selector: 'pv-custom-list',
  templateUrl: './custom-list.component.html',
  styleUrls: ['./custom-list.component.scss']
})
export class CustomListComponent implements AfterViewInit {

  @Input('columns')
  set columns(columns: Array<CustomListColumn>) {
    this._columns = columns;
    this.displayedColumns = this.columns.map(col => col.key);
  };
  get columns() {
    return this._columns;
  }

  @Input() pageSizeOptions: number[] = [5, 10, 25, 50];
  @Input() pageSize = 10;
  @Input() totalItems = 0;
  @Input() initialSort: any = null;
  @Input() isLoading: boolean = false;
  @Input() loadingMessage: string = 'Loading...';
  @Input() emptyMessage: string = 'No data found';

  @Output() rowClick = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<{pageIndex: number, pageSize: number}>();
  @Output() sortChange = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @Input() dataSource: CustomListDataSourceService<any>;
  displayedColumns: string[] = [];

  private _columns;
  private isInitialSortBeingApplied = false;

  constructor(private cdr: ChangeDetectorRef, private elementRef: ElementRef) {}

  ngAfterViewInit() {
    if (this.initialSort && this.sort) {
      // Apply initial sort after a brief delay to ensure everything is initialized
      setTimeout(() => {
        this.applyInitialSort();
      }, 100);
    }

    try {
      setTimeout(() => {
        if (this.dataSource && (this.dataSource as any).bindPaginator && this.paginator) {
          try {
            (this.dataSource as any).bindPaginator(this.paginator);
          } catch (e) {
          }
        }
      }, 0);
    } catch (e) {
    }
  }

  private applyInitialSort() {
    if (this.sort && this.initialSort) {
      this.sort.sort({
        id: this.initialSort.active,
        start: this.initialSort.direction,
        disableClear: false
      });
      
      this.isInitialSortBeingApplied = false;
      this.cdr.detectChanges();
    }
  }

  onSortChange(sort: any) {
    if (this.dataSource && this.dataSource.sortChanged) {
      this.dataSource.sortChanged(sort);
    }
    
    this.sortChange.emit(sort);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Check if the click was outside the table component
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      // Clear selection when clicking outside
      if (this.dataSource && this.dataSource.clearSelection) {
        this.dataSource.clearSelection();
      }
    }
  }
}
